var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inputer-check"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.change}}),(_vm.changed)?_c('div',{staticClass:"changed",attrs:{"title":"Neuložená změna"}},[_c('i',{staticClass:"fa fa-wrench"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }